import {useTranslation} from "react-i18next";
import {CountrySelectorConfig} from "../../../configs/demo-pages/countrySelectorConfig.ts";

const CountrySelector = ({setCountry}: {setCountry: (arg0: string) => void}) => {

    const { t } = useTranslation();

    return (
        <>
            <div className="country_el mb-3">
                <label
                    className="text-center text-md-start fs-6 mb-4 text-blue-dark fw-semibold"
                    htmlFor="select_country"
                >
                    {t('select_country')}:
                </label>
                <select onChange={(e) => setCountry(e.target.value)} id="select_country" name="select_country">
                    {CountrySelectorConfig.map((country, index) => (
                        <option key={index} value={country.code}>{t(country.title)}</option>
                    ))}
                </select>
            </div>
        </>
    )
}

export default CountrySelector;
